import { formatDate, Location } from '@angular/common';
import { Component, computed, HostListener, inject, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { SubrentalCutoffEnums } from 'src/app/enum/subrental-cutoff-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { FormatModel } from 'src/app/models/formats/format.model';
import { BranchModel } from 'src/app/models/management/branch.model';
import { LiquidationPrintModel } from 'src/app/models/print/subrental/liquidation-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { SubrentalCutoffModel } from 'src/app/models/subrental/subrental-cutoff.model';
import { SubrentalCutoffStoreModalModel } from 'src/app/models/tables/subrental/subrental-cutoff-store-modal.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { SubrentalCutoffDetailService } from 'src/app/services/subrental/subrental-cutoff-detail.service';
import { SubrentalCutoffService } from 'src/app/services/subrental/subrental-cutoff.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { LiquidationComponent } from '../liquidation/liquidation.component';

@Component({
  selector: 'app-register-subrental-cutoff',
  templateUrl: './register-subrental-cutoff.component.html',
  styleUrls: ['./register-subrental-cutoff.component.scss'],
  standalone: false,
})
export class RegisterSubrentalCutoffComponent implements OnInit, OnDestroy {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly formatService = inject(FormatService);
  private readonly headerService = inject(HeaderService);
  private readonly subrentalCutoffService = inject(SubrentalCutoffService);
  private readonly subrentalCutoffDetailService = inject(SubrentalCutoffDetailService);
  private readonly location = inject(Location);
  private readonly optionWindowService = inject(OptionWindowService);
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  readonly state = signal<number>(SubrentalCutoffEnums.open);
  readonly stateButtonLabel = computed(() =>
    (this.state() === SubrentalCutoffEnums.open || this.state() === SubrentalCutoffEnums.liquidated) ? 'Cerrar' : 'Reversar Estado'
  );
  readonly stateButtonIcon = computed(() =>
    (this.state() === SubrentalCutoffEnums.open || this.state() === SubrentalCutoffEnums.liquidated) ? 'pi pi-lock-open' : 'pi pi-lock'
  );

  @ViewChild('liquidatedModal') liquidatedModalComponent?: CustomModalComponent | null = null;
  @ViewChild('selectStore') selectStoreModalComponent?: CustomModalComponent | null = null;

  ascendantStore: boolean = true;
  branchId: number = 0;
  columnSortStore: string | null = null;
  companyCutsAmount: number = 0;
  companyId: number = 0;
  dataStores: PagedResponseModel<SubrentalCutoffStoreModalModel> = new PagedResponseModel<SubrentalCutoffStoreModalModel>();
  detailWithoutMovement: boolean = false;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  disabledInvoice: boolean = true;
  disabledSelectStore: boolean = false;
  disabledState: boolean = true;
  exporterDetailsPreview: boolean = false;
  filtersStores: ColumnResponseModel[] = [];
  formSubrentalCutoff: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  headerStores: ColumnResponseModel[] = [];
  iconPreviewSubrentalCutoff: string = "pi pi-eye";
  inputsForStoreModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  });
  inputsForLiquidatedModal$ = new BehaviorSubject<any>({
    subrentalCutoffId: 0,
    branchName: '',
    subrentalCutoffCode: '',
    subrentalCutoffDate: ''
  });
  isOpened: string | undefined = undefined;
  limitStore: number = 10;
  liquidatedCutoffLabel: string = '';
  liquidationPrintModel: LiquidationPrintModel[] = [];
  listBranch: any[] = [];
  listUserAutheticated: Array<ItemFilterModel> = new Array<ItemFilterModel>();
  mainBranchByUser: BranchModel = new BranchModel();
  nameWindow: string = 'Captura Cortes Subalquiler';
  openCutsAmount: number = 0;
  output$ = new Subject<any>();
  pageStore: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  previewSubrentalCutoff: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  storeId: number | null = null;
  subrentalCutoffContract: SubrentalCutoffModel = new SubrentalCutoffModel();
  subrentalCutoffId: number = 0;
  subrentalCutoffStateString: string = '';
  subrentalStateOpen = SubrentalCutoffEnums.open;
  subscription: Subscription;
  titlePreviewSubrentalCutoff: string = "Vista Previa";
  updateListDetail: boolean = false;
  url: string = 'subrental-cutoff';
  userAuthenticated: UserModel = new UserModel();
  visibleLoading: boolean = true;
  componentTableSelection = CustomTableSelectComponent;
  liquidatedComponent = LiquidationComponent;

  async ngOnInit() {
    this.validateForm(this.subrentalCutoffContract);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.subrentalCutoffId = Object.keys(params).length > 0 ? params?.id : null;
    });
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeStore(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeStore(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    this.headerService.setTitle(this.nameWindow);
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    try {
      const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
      if (windowsOpenedJson) {
        const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
        const windowIndex = windowsOpened.findIndex(x => x === this.url);
        if (windowIndex !== -1) {
          windowsOpened.splice(windowIndex, 1);
          localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
        }
      }
    } catch (error) {
      console.error('Problemas al ejecutar ngOnDestroy()', error);
    }
  }

  async changeBranch(branchId: number) {
    this.subrentalCutoffContract = new SubrentalCutoffModel();
    this.subrentalCutoffContract.branchId = branchId;
    this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
    this.validateForm(this.subrentalCutoffContract);
  }

  async changeConsecutive(consecutive: number) {
    const branchId = this.formSubrentalCutoff.get("branchId")?.value;

    if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
      return;
    }
    try {
      this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getSubrentalCutoffByKeysAsync(this.branchId, consecutive));
      this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
      this.validateForm(this.subrentalCutoffContract);
      this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
    } catch (error) {
      this.subrentalCutoffContract = new SubrentalCutoffModel();
      this.subrentalCutoffContract.branchId = branchId;
      this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
      this.validateForm(this.subrentalCutoffContract);
      console.error('Error al obtener el corte de subalquiler por claves.', error);
    }

  }

  async createDetail(stores: SubrentalCutoffStoreModalModel[]) {
    const availablePlaces = 100 - this.quantityDetails;
    if (stores && stores.length > availablePlaces) {
      this.toastHandlerService.showToast('warning', `No se pueden agregar más de ${availablePlaces} bodegas.`);
      return;
    }
    if (stores.length != 0) {
      const storesIds = stores.map(d => d.storeId);
      try {
        await firstValueFrom(this.subrentalCutoffDetailService.createSubrentalCutoffDetail(this.subrentalCutoffId, storesIds));
        this.updateListDetail = !this.updateListDetail;
      } catch (error) {
        console.error('Error al crear los detalles del corte de subalquiler.', error);
      }
    }
  }

  async createNewSubrentalCutoff(branchId: number) {
    if (this.permissionUpdatable) {
      await this.validateCountSubrentalCutoffsOpen(this.branchId);

      if (this.companyCutsAmount != 0) {
        if (this.companyCutsAmount == this.openCutsAmount) { return; }
      }

      this.state.set(SubrentalCutoffEnums.open);
      const branchIdNew = branchId !== 0 ? branchId : this.mainBranchByUser.branchId;
      this.subrentalCutoffId = 0;
      this.subrentalCutoffContract.branchId = branchIdNew;
      this.subrentalCutoffContract.consecutive = 0;
      this.validateForm(this.subrentalCutoffContract);
      this.getBranch(branchIdNew, true);
      if (this.permissionUpdatable) {
        this.disabledState = false;
      } else {
        this.updateFormPermision();
      }
      this.quantityDetails = 0;
      this.router.navigate(['/subrental-cutoff/register']);
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para crear cortes de subalquiler. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async deleteSubrentalCutoff() {
    if (this.subrentalCutoffContract.subrentalCutoffId != 0 && this.subrentalCutoffContract.subrentalCutoffId != null) {
      if (this.permissionUpdatable) {
        if (this.subrentalCutoffContract.subrentalCutoffStateId === SubrentalCutoffEnums.open) {
          const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar el corte de subalquiler actual?');
          if (accepted) {
            try {
              await firstValueFrom(this.subrentalCutoffService.deleteSubrentalCutoff(this.subrentalCutoffId));
              this.createNewSubrentalCutoff(0);
              this.toastHandlerService.showToast(
                'success',
                'El corte de subalquiler fue eliminado exitosamente.'
              );
            } catch (error) {
              console.error("Error al eliminar el corte de subalquiler: ", error);
            }
          }
        } else {
          this.toastHandlerService.showToast(
            'warning',
            'Para eliminar el corte de subalquiler debe estar en estado Abierto.'
          );
        }
      } else {
        this.toastHandlerService.showToast(
          'warning',
          'El usuario no tiene permisos para eliminar cortes de subalquiler. Comuníquese con el administrador del sistema.'
        );
        return;
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un corte de subalquiler.'
      );
      return;
    }
  }

  exporterDetailsPreviewPrint() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.ExportarVistaPrevia)) {
      this.exporterDetailsPreview = !this.exporterDetailsPreview;
    } else {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para exportar la Vista Previa de cortes de subalquiler, comuniquese con el administrador del sistema.', 'Atención');
    }
  }

  async getBranch(branchId: number | null, reload: boolean) {
    if (branchId != null) {
      const branch = this.listBranch.find(x => x.value == branchId);
      if (branch) {
        this.branchId = branchId;
      } else {
        this.formSubrentalCutoff.controls["branchId"].setValue(0);
        return;
      }
    } else {
      this.formSubrentalCutoff.controls["branchId"].setValue(0);
    }
    if (branchId && reload) {
      await this.changeBranch(branchId);
    }
  }

  async getButtonClick(buttonClick: any) {
    const branchId = this.formSubrentalCutoff.get("branchId")?.value;
    const consecutive = this.formSubrentalCutoff.get("consecutive")?.value;

    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    }

    switch (buttonClick.target.id) {
      case 'first': {
        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getFirstSubrentalCutoffByKeysAsync(branchId));
          this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
          this.validateForm(this.subrentalCutoffContract);
          this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
        } catch (error) {
          this.createNewSubrentalCutoff(branchId);
          console.error('Error al obtener el primer corte de subalquiler por claves.', error);
        }
        break;
      }
      case 'previus': {
        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getPreviusSubrentalCutoffByKeysAsync(branchId, consecutive));
          this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
          this.validateForm(this.subrentalCutoffContract);
          this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
        } catch (error) {
          this.createNewSubrentalCutoff(branchId);
          console.error('Error al obtener el anterior corte de subalquiler por claves.', error);
        }
        break;
      }
      case 'next': {
        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getNextSubrentalCutoffByKeysAsync(branchId, consecutive));
          this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
          this.validateForm(this.subrentalCutoffContract);
          this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
        } catch (error) {
          this.createNewSubrentalCutoff(branchId);
          console.error('Error al obtener el siguiente corte de subalquiler por claves.', error);
        }
        break;
      }
      case 'last': {
        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getLastSubrentalCutoffByKeysAsync(branchId));
          this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
          this.validateForm(this.subrentalCutoffContract);
          this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
        } catch (error) {
          this.createNewSubrentalCutoff(branchId);
          console.error('Error al obtener el último corte de subalquiler por claves.', error);
        }
        break;
      }
    }
    if (this.previewSubrentalCutoff) {
      this.getPrintLiquidated();
    }
  }

  async getColumnsStores() {
    try {
      if (this.headerStores.length === 0) {
        this.headerStores = await firstValueFrom(this.subrentalCutoffDetailService.getColumnsForStores());
      }
    } catch (error) {
      console.error('Error al obtener las columnas de las bodegas.', error);
    }
  }

  getFilterPreview(filters: any[]) {
    this.storeId = filters.find(x => x.label == 'storeId').value;
    this.getPrintLiquidated();
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      this.mainBranchByUser = await firstValueFrom(this.userAuthenticatedService.branchObservable.pipe(filter(branch => branch && branch.branchId !== 0)));
      this.companyId = this.mainBranchByUser.companyId;
      this.branchId = this.mainBranchByUser.branchId;
      await this.getBranch(this.mainBranchByUser.branchId, false);
      this.formSubrentalCutoff.controls["branchId"].patchValue(this.mainBranchByUser.branchId);
    } catch (error) {
      console.error('Error al obtener la primera sucursal por usuario autenticado:', error);
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0) {
      this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.liquidation));
    }
  }

  async getListBranches() {
    try {
      this.listBranch = await firstValueFrom(this.branchService.getAllBranchesForSelectAsync());
    } catch (error) {
      console.error('Error al obtener la lista de sucursales.', error);
    }
  }

  async getStoresForSubrentalCutoff() {
    try {
      this.dataStores = await firstValueFrom(
        this.subrentalCutoffDetailService.getStoresForSubrentalCutoffAsync(
          this.subrentalCutoffContract.subrentalCutoffId,
          this.pageStore,
          this.limitStore,
          this.columnSortStore,
          this.ascendantStore,
          this.filtersStores
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de las bodegas.', error);
    }
  }

  async getSubrentalCutoffById() {
    try {
      this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.getSubrentalCutoffById(this.subrentalCutoffId));
      this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
      this.router.navigate([`/subrental-cutoff/register/${this.subrentalCutoffId}`]);
    } catch (error) {
      console.error('Error al obtener el corte por Id.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    this.getFormatByCompanyAndCode();
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
      await this.getListBranches();
    } catch (error) {
      console.error('Error getting profile permissions.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.SubrentalCutoff));
  }

  async getPrintLiquidated() {
    try {
      this.visibleLoading = true;
      this.liquidationPrintModel = await firstValueFrom(this.subrentalCutoffService.getLiquidationCutoffByKeysAsync(
        this.branchId, this.subrentalCutoffContract.consecutive, this.subrentalCutoffId, this.storeId
      ));
      if (this.liquidationPrintModel.length == 0) {
        this.toastHandlerService.showToast('info', 'No hay datos disponibles.');
      }
      // branchId: number, consecutive: number, subrentalCutoffId: number | null, storeId: number | null)
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  getQuantityDetails(quantityDetails: number) {
    this.quantityDetails = quantityDetails;
    if (this.quantityDetails > 0) {
      this.disabledForm = true;
      setTimeout(() => this.formSubrentalCutoff.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formSubrentalCutoff, ['branchId', 'consecutive'], true), 100);
    } else {
      this.updateFormState();
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    if (this.previewSubrentalCutoff) {
      this.previewSubrentalCutoff = false;
      this.iconPreviewSubrentalCutoff = "pi pi-eye";
      this.titlePreviewSubrentalCutoff = "Vista Previa";
    } else {
      this.router.navigate(['/subrental-cutoff']);
    }
  }

  async handleInitialState() {
    if (this.subrentalCutoffId !== null && this.subrentalCutoffId !== 0) {
      await this.getSubrentalCutoffById();
      if (this.subrentalCutoffContract.subrentalCutoffId !== 0) {
        this.formSubrentalCutoff.enable();
        this.validateForm(this.subrentalCutoffContract);
        this.getBranch(this.subrentalCutoffContract.branchId, false);

        if (!this.permissionUpdatable) {
          this.updateFormPermision();
        }
      }
    } else {
      this.createNewSubrentalCutoff(0);
    }
  }

  async onFilterChangeStore(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersStores = this.removeDuplicates(filters);
    this.filtersStores.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeStore(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }) {
    this.pageStore = event.page;
    this.limitStore = event.pageSize;
    this.columnSortStore = event.sortField || null;
    this.ascendantStore = event.sortOrder === 1;
    this.getStoresForSubrentalCutoff();
  }

  async changeState() {
    if (this.subrentalCutoffContract.subrentalCutoffId == 0 && this.subrentalCutoffContract.subrentalCutoffId == null) {
      this.toastHandlerService.showToast('warning', 'Debe crear un corte de subalquiler.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para cerrar cortes de subalquiler. Comuníquese con el administrador del sistema.'
      );
      return;
    }
    if (this.subrentalCutoffContract.subrentalCutoffStateId === SubrentalCutoffEnums.open) {
      this.toastHandlerService.showToast(
        'warning',
        'Para cerrar el corte de subalquiler debe estar en estado liquidado.'
      );
      return;
    }

    const closeMessage = "Al cerrar el corte de subalquiler se eliminarán las bodegas sin movimiento, ¿Desea continuar?";
    const openMessage = "¿Desea reversar el estado del corte de subalquiler?";
    const accepted = await this.confirmDialogService.confirm(
      this.subrentalCutoffContract.subrentalCutoffStateId === SubrentalCutoffEnums.liquidated ? closeMessage : openMessage
    );
    if (accepted) {
      try {
        await firstValueFrom(this.subrentalCutoffService.openCloseSubrentalCutoff(this.subrentalCutoffId));
        this.updateSubrentalCutoff({ reload: true });
        this.toastHandlerService.showToast(
          'success',
          'El estado del corte de subalquiler se actualizó exitosamente.'
        );
      } catch (error) {
        console.error("Error al cambiar el estado del corte de subalquiler: ", error);
      }
    }
  }

  async openLiquidatedModal() {
    if (this.permissionUpdatable) {
      if (this.subrentalCutoffContract.subrentalCutoffStateId == SubrentalCutoffEnums.open) {
        this.liquidatedModalComponent && this.liquidatedModalComponent.show();
      } else if (this.subrentalCutoffContract.subrentalCutoffStateId == SubrentalCutoffEnums.liquidated) {
        try {
          await firstValueFrom(this.subrentalCutoffService.openSubrentalCutoffById(this.subrentalCutoffContract.subrentalCutoffId));
          this.updateSubrentalCutoff({ reload: true });
        } catch (error) {
          console.error('Error al reversar el estado del corte de subalquiler.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast(
        'error',
        'El usuario no tiene permisos para cambiar estado del corte de subalquiler. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async openPreviewSubrentalCutoff() {
    if (this.subrentalCutoffContract.subrentalCutoffId != 0) {
      this.previewSubrentalCutoff = !this.previewSubrentalCutoff;
      if (this.previewSubrentalCutoff) {
        this.iconPreviewSubrentalCutoff = "pi pi-address-book";
        this.titlePreviewSubrentalCutoff = "Volver al corte de subalquiler";
        this.getPrintLiquidated();
      } else {
        this.iconPreviewSubrentalCutoff = "pi pi-eye";
        this.titlePreviewSubrentalCutoff = "Vista Previa";
      }
    } else {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado del corte de subalquiler.`, 'Atención');
    }
  }

  async openSelectStoreModal() {
    if (this.subrentalCutoffContract.subrentalCutoffId === 0) {
      this.toastHandlerService.showToast('warning', `Debe crear el encabezado del corte de subalquiler.`, 'Atención');
      return;
    }
    this.filtersStores = [];
    await Promise.all([
      this.getColumnsStores(),
      this.getStoresForSubrentalCutoff(),
    ]);
    this.updateInputs();

    if (this.selectStoreModalComponent && this.headerStores) {
      this.selectStoreModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'error',
        'No se pudieron cargar los centros de costos. Por favor, inténtelo de nuevo.'
      );
    }
  }

  printLiquidated() {
    window.print();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersStores = this.filtersStores.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersStores.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    Object.keys(this.formSubrentalCutoff.controls).forEach(key => {
      const control = this.formSubrentalCutoff.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formSubrentalCutoff.valid) {
      this.formSubrentalCutoff.controls['consecutive'].enable();
      const modelSubrentalCutoff = this.formSubrentalCutoff.getRawValue() as SubrentalCutoffModel;

      if (modelSubrentalCutoff.observation?.trim() == "") modelSubrentalCutoff.observation = null;

      if (this.subrentalCutoffId == 0) {
        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.createSubrentalCutoff(modelSubrentalCutoff));
          this.subrentalCutoffId = this.subrentalCutoffContract.subrentalCutoffId;
          this.validateForm(this.subrentalCutoffContract);
          this.toastHandlerService.showToast(
            'success',
            'El corte de subalquiiler fue creado exitosamente.'
          );
          this.location.replaceState(`/subrental-cutoff/register/${this.subrentalCutoffId}`);
        } catch (error) {
          console.error('Error al crear el corte de subalquiler:', error);
        }
      } else {
        this.subrentalCutoffContract.dateSubrentalCutoff = modelSubrentalCutoff.dateSubrentalCutoff;
        this.subrentalCutoffContract.observation = modelSubrentalCutoff.observation;

        try {
          this.subrentalCutoffContract = await firstValueFrom(this.subrentalCutoffService.updateSubrentalCutoff(this.subrentalCutoffContract));
          this.validateForm(this.subrentalCutoffContract);
          this.toastHandlerService.showToast(
            'success',
            'El corte de subalquiler fue modificado exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar el corte de subalquiler:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }

  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      consecutive: {
        required: 'El campo Consecutivo es obligatorio.'
      },
      dateSubrentalCutoff: {
        required: 'La Fecha de Corte es obligatoria.'
      },
      subrentalCutoffStateId: {
        required: 'El Estado del Corte es obligatorio.',
        min: 'Debes seleccionar un Estado de Corte válido.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formSubrentalCutoff.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs(liquidatedModal: boolean = false) {
    if (liquidatedModal) {
      this.inputsForLiquidatedModal$.next({
        subrentalCutoffId: this.subrentalCutoffId,
        branchName: this.listBranch.find(x => x.value === this.subrentalCutoffContract.branchId).label,
        subrentalCutoffCode: this.subrentalCutoffContract.consecutive,
        subrentalCutoffDate: formatDate(this.dateConverterService.convertUtcToLocalDate(this.subrentalCutoffContract.dateSubrentalCutoff), 'dd/MM/yyyy', 'en-US')
      });
    } else {
      this.inputsForStoreModal$.next({
        headers: this.headerStores,
        data: this.dataStores,
        showCheckbox: true,
        showRecover: true,
        isMultipleSelect: true,
        filters: this.filtersStores,
      });
    }
  }

  async updateSubrentalCutoff(params: any) {
    if (params.reload) {
      await this.getSubrentalCutoffById();
      this.validateForm(this.subrentalCutoffContract);
    }
  }

  updateFormPermision() {
    switch (this.subrentalCutoffContract.subrentalCutoffStateId) {
      case SubrentalCutoffEnums.open: {
        this.subrentalCutoffStateString = "Abierto";
        this.liquidatedCutoffLabel = "Liquidar";
        break;
      }
      case SubrentalCutoffEnums.liquidated: {
        this.subrentalCutoffStateString = "Liquidado";
        this.liquidatedCutoffLabel = "Abrir";
        break;
      }
      case SubrentalCutoffEnums.closed: {
        this.subrentalCutoffStateString = "Cerrado";
        this.liquidatedCutoffLabel = "Abrir";
        break;
      }
    }

    this.disabledDetail = false;
    this.disabledForm = true;
    this.disabledState = false;
    this.disabledInvoice = true;
    this.disabledSelectStore = true;

    setTimeout(() => this.formSubrentalCutoff.disable(), 100);
    setTimeout(() => this.formControlStateService.setControlState(this.formSubrentalCutoff, ['branchId', 'consecutive'], true), 100);
  }

  updateFormState() {
    switch (this.subrentalCutoffContract.subrentalCutoffStateId) {
      case SubrentalCutoffEnums.open: {
        this.subrentalCutoffStateString = "Abierto";
        this.liquidatedCutoffLabel = "Liquidar";
        break;
      }
      case SubrentalCutoffEnums.liquidated: {
        this.subrentalCutoffStateString = "Liquidado";
        this.liquidatedCutoffLabel = "Abrir";
        break;
      }
      case SubrentalCutoffEnums.closed: {
        this.subrentalCutoffStateString = "Cerrado";
        this.liquidatedCutoffLabel = "Abrir";
        break;
      }
    }

    if (this.subrentalCutoffContract.subrentalCutoffStateId == SubrentalCutoffEnums.liquidated) {
      this.disabledDetail = false;
      this.disabledForm = true;
      this.disabledInvoice = false;
      this.disabledSelectStore = true;
      this.disabledState = true;
      setTimeout(() => this.formSubrentalCutoff.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formSubrentalCutoff, ['branchId', 'consecutive'], true), 100);
    } else if (this.subrentalCutoffContract.subrentalCutoffStateId == SubrentalCutoffEnums.closed) {
      this.disabledDetail = false;
      this.disabledForm = true;
      this.disabledInvoice = true;
      this.disabledSelectStore = true;
      this.disabledState = false;
      setTimeout(() => this.formSubrentalCutoff.disable(), 100);
      setTimeout(() => this.formControlStateService.setControlState(this.formSubrentalCutoff, ['branchId', 'consecutive'], true), 100);
    } else {
      this.disabledDetail = true;
      this.disabledForm = false;
      this.disabledInvoice = true;
      this.disabledSelectStore = false;
      this.disabledState = true;
      setTimeout(() => this.formSubrentalCutoff.enable(), 100);
      if (this.quantityDetails > 0) {
        this.disabledForm = true;
        setTimeout(() => this.formSubrentalCutoff.disable(), 100);
      }
      if (this.subrentalCutoffId !== 0) {
        setTimeout(() => this.formControlStateService.setControlState(this.formSubrentalCutoff, ['branchId', 'consecutive'], true), 100);
      } else {
        setTimeout(() => this.formSubrentalCutoff.controls["consecutive"].disable(), 100);
      }
    }
  }

  async validateCountSubrentalCutoffsOpen(branchId: number) {
    try {
      const response = await firstValueFrom(this.subrentalCutoffService.validateCountSubrentalCutoffsOpen(branchId));
      this.companyCutsAmount = response[0] as number; //Si la cantidad es 0 es porque no hay límite de cortes abiertos
      this.openCutsAmount = response[1] as number;
      if (this.openCutsAmount != 0) {
        if (this.companyCutsAmount == 0) {
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCutsAmount} corte(s) con estado abierto o liquidado.`
          );
        } else {
          //Mensaje con el número de cortes
          this.toastHandlerService.showToast(
            'info',
            `Existen (${this.openCutsAmount}) Corte(s) con estado abierto o liquidado. El máximo de cortes permitidos son (${this.companyCutsAmount})`
          );
        }
      }
    } catch (error) {
      console.error('Error al buscar el formato de impresión.', error);
    }
  }

  async validateForm(subrentalCutoffModel: SubrentalCutoffModel) {
    this.formSubrentalCutoff = this.formBuilder.group({
      branchId: [subrentalCutoffModel.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [subrentalCutoffModel.consecutive, [Validators.required]],
      dateSubrentalCutoff: [subrentalCutoffModel.dateSubrentalCutoff ? this.dateConverterService.convertDatePreserveDay(subrentalCutoffModel.dateSubrentalCutoff) : null, [Validators.required]],
      subrentalCutoffStateId: [subrentalCutoffModel.subrentalCutoffStateId, [Validators.required, Validators.min(1)]],
      observation: [subrentalCutoffModel.observation, [Validators.maxLength(250)]]
    });
    this.state.set(subrentalCutoffModel.subrentalCutoffStateId);
    this.updateFormState();
    if (subrentalCutoffModel.subrentalCutoffId !== 0) {
      this.updateInputs(true);
    }
  }

  visiblePreview(visible: boolean) {
    this.visibleLoading = !visible;
  }

}
